
import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import {getBagagesFailure, getBagagesStart, getBagagesSuccess,} from './BagageAction';

const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const getBagages = async(dispatch, pageSize, page, idEnvoie, idAction)=>{
    let filter = { idEnvoie, idAction };
    dispatch(getBagagesStart());
    try{
        const res = await axiosInstance.post(`/admin/cart/bagages?pageSize=${pageSize}&page=${page}`,filter,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getBagagesSuccess(res.data));
    }catch(err){
        if(err.response){
            dispatch(getBagagesFailure(err.response.data.message))
        }else{
            dispatch(getBagagesFailure("Unkown Error"))
        }
    }
}